import {
  CREATE_DAILY_INTERNATIONAL_POWER_METER_REPORT,
  DELETE_DAILY_INTERNATIONAL_POWER_METER_REPORT,
  EDIT_DAILY_INTERNATIONAL_POWER_METER_REPORT,
  RECEIVE_DAILY_INTERNATIONAL_POWER_METER_REPORTS,
  REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORT,
  REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE,
} from '@sophocles/entities/DailyInternationalPowerMeterReport/dailyInternationalPowerMeterReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_DAILY_INTERNATIONAL_POWER_METER_REPORTS: // Read
      return state.merge(action.dailyInternationalPowerMeterReports);
    case DELETE_DAILY_INTERNATIONAL_POWER_METER_REPORT: // Delete
      return state.delete(action.dailyInternationalPowerMeterReport.toString());
    case EDIT_DAILY_INTERNATIONAL_POWER_METER_REPORT: // Update
    case CREATE_DAILY_INTERNATIONAL_POWER_METER_REPORT: // Create
    case REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
    default:
      return state;
  }
}

export function dailyInternationalPowerMeterReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_DAILY_INTERNATIONAL_POWER_METER_REPORT:
    case DELETE_DAILY_INTERNATIONAL_POWER_METER_REPORT:
    case RECEIVE_DAILY_INTERNATIONAL_POWER_METER_REPORTS:
    case EDIT_DAILY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORT:
    case REQUEST_DAILY_INTERNATIONAL_POWER_METER_REPORTS_FOR_SITE_WITH_RANGE:
      return getState(state, action);
    default:
      return state;
  }
}
